<template>
    <v-app :lang="$i18n.locale">
        <div class="applicants-download">
            <div class="page" :key="index0" v-for="(items, index0) in students">
                <!-- Header for every page -->
                <div class="page-header">
                    <div class="report-title">
                        <img class="school-logo" :src="organizationDetail?.school_logo_base64?.data" alt="logo" />
                        <p class="main-title">{{ reportTitle }}</p>
                        <p class="school-name">โรงเรียน ภ.ป.ร. ราชวิทยาลัย ในพระบรมราชูปถัมภ์</p>
                        <p class="report-detail">{{ reportDetail }}</p>
                    </div>
                </div>

                <!-- Table content -->
                <div class="table-container">
                    <table>
                        <thead>
                            <tr class="default">
                                <th>{{ $t("message.common.applicantReport.tableHeader.indexNo") }}</th>
                                <th>{{ $t("message.common.applicantReport.tableHeader.applicationID") }}</th>
                                <th>{{ $t("message.common.applicantReport.tableHeader.fullName") }}</th>
                                <th v-if="!programName">{{ $t("message.common.applicantReport.tableHeader.curriculum") }}</th>
                                <th v-else style="width: 150px;">{{ $t("message.common.applicantReport.tableHeader.remark") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :key="index" v-for="(item, index) in items">
                                <td align="center">{{ getIndexNo(index0, index) }}</td>
                                <td align="center">{{ getApplicationID(item) }}</td>
                                <td align="left">{{ getFullName(item) }}</td>
                                <td align="left" v-if="!programName">{{ getCurriculumName(item) }}</td>
                                <td align="left" v-else>{{ studentResultTypeMapping[item.result_type]?.[`text_${locale}`] ?? "" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Footer for every page -->
                <div class="page-footer">
                    <div class="footer-content">
                        <span class="footer-center">{{ datePrint }}</span>
                    </div>
                </div>
            </div>
        </div>
</v-app>
</template>

<script>
import { formatDateTime, dateTimeLocale } from "@/utils/date";
import { getFullGrade, getStudentYear } from "@/utils/studentYear";
import { genApplicationID } from "@/utils/applicant";
import { STUDENT_RESULT_TYPE_MAPPING } from "@/constants";
import i18n from '@/i18n';
export default {
    name: "ApplicantPart",
    props: {
        reportTitle: String,
        programName: String,
        organizationDetail: Object,
        registrationFormDetail: Object,
        studentDataList: [],
    },
    data () {
        return {
            rowPage1: 28,
            rowPages: 28,
            studentResultTypeMapping: STUDENT_RESULT_TYPE_MAPPING,
        }
    },
    computed: {
        locale() {
            return i18n.locale;
        },
        students() {
            // let studentList = [];
            // for (let i = 0; i < 50; i++) {
            //     studentList = [...studentList, ...this.studentDataList]
            // }

            const studentList = this.studentDataList?.filter((item => item.index_number)) ?? [];
            if (studentList?.length <= this.rowPage1) {
                return [studentList];
            } else {
                return [...[studentList.slice(0, this.rowPage1)], ...this.chunk(studentList.slice(this.rowPage1), this.rowPages)];
            }
        },
        datePrint() {
            let newDate = new Date();
            if (this.locale == 'th') {
                return `ออกรายงาน ณ วันที่ ${formatDateTime(newDate, this.locale)} เวลา ${dateTimeLocale('HH:mm', this.locale)} น.`
            } else {
                return `Report on ${formatDateTime(newDate, this.locale)} Time ${dateTimeLocale('HH:mm', this.locale)}`
            }
        },
        reportDetail() {
            return `${this.$t("message.common.academic_year")} ${this.registrationFormDetail?.semester_year} ${getFullGrade(this.registrationFormDetail?.grade_level, this.locale)} ${getStudentYear(this.registrationFormDetail?.grade_level)} ${this.programName ? this.$t('message.common.curriculum') + ' ' + this.programName : ''}`
        },
    },
    methods: {
        chunk(array, chunk_size) {
            if (array.length == 0) return [];
            else return [array.splice(0, chunk_size)].concat(this.chunk(array, chunk_size))
        },
        getIndexNo(index0, index) {
            let indexNo = 0;
            if (index0 == 0) {
                indexNo = (index + 1);
            } else {
                indexNo = this.rowPage1 + (this.rowPages * (index0 - 1)) + (index + 1);
            }

            return indexNo;
        },
        getApplicationID(student) {
            return genApplicationID(this.registrationFormDetail?.grade_level, student?.index_number)
        },
        getFullName(student) {
            if (this.locale == 'th') {
                return `${student?.student_detail?.name_th} ${student?.student_detail?.surname_th}`
            } else {
                return `${student?.student_detail?.name_en} ${student?.student_detail?.surname_en}`
            }
        },
        getCurriculumName(student) {
            const program = student?.student_detail?.program
            return this.locale == 'th' ? program?.program_name_th : program?.program_name_en ?? program?.program_name_th
        },
    }
};
</script>

<style scoped lang="scss">
.applicants-download {
    margin: 0px 20px;
    text-align: center;
    color: #000000;
    font-family: 'Sarabun', sans-serif;

    .v-application[lang='en'] & {
        font-family: 'inter', sans-serif !important;
    }

    .page {
        min-height: 840px;
        display: flex;
        flex-direction: column;
        page-break-after: always;
        page-break-inside: avoid;
        margin-top: 0.5rem;
        margin-bottom: 0.1rem;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .page-header {
        .report-title {
            font-size: 18px;
            padding-bottom: 0.25rem;

            .main-title {
                font-size: 20px;
                font-weight: bold;
                margin: 0.25rem 0;
            }

            .school-name {
                font-size: 18px;
                font-weight: 600;
                margin: 0.25rem 0;
            }

            .report-detail {
                font-size: 16px;
                margin: 0.25rem 0;
            }

            .page-number {
                font-size: 14px;
                color: #666;
                margin: 0.25rem 0;
            }

            img.school-logo {
                height: 125px;
            }
        }
    }

    .table-container {
        flex: 1;
        min-height: 825px;
        table {
            width: 100%;
            border-collapse: collapse;

            thead tr:nth-child(1) th {
                width: 8%;
                &:nth-child(2) {
                    width: 20%;
                }
                &:nth-child(3) {
                    width: 47%;
                }
                &:nth-child(4) {
                    width: 25%;
                }
            }
        }

        th {
            font-size: 16px;
            height: 36px;
            border: 1px solid #000000;
            padding: 0 4px;
            background-color: #f5f5f5;
        }

        td {
            font-size: 16px;
            height: 28px;
            border: 1px solid #000000;
            padding: 0 4px;
        }

        tr.default > th,
        td.default {
            position: relative;
            background-color: #bfbfc2;
        }
    }

    .page-footer {
        margin-top: auto;
        padding-top: 0.25rem;
        .footer-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            padding: 0.5rem 0;

            .footer-left {
                flex: 1;
                text-align: left;
            }

            .footer-center {
                flex: 2;
                text-align: center;
                font-weight: 500;
            }

            .footer-right {
                flex: 1;
                text-align: right;
            }
        }
    }
}

@media print {
    .page {
        page-break-after: always;
        page-break-inside: avoid;
    }
}
</style>

